<template>
  <div class="valid-statuses">
    <label class="form-create__label" :for="inputId">{{ $t("validStatuses.label") }}</label>
    <p class="valid-statuses__hint">
      {{ $t("validStatuses.hint") }}
    </p>

    <div class="valid-statuses__chips">
      <span v-for="status in value" :key="status" class="valid-statuses__chip">
        {{ status }}
        <button
          type="button"
          :aria-label="$t('validStatuses.remove', { status })"
          @click="remove(status)"
        >
          ×
        </button>
      </span>
      <input
        :id="inputId"
        v-model.trim="draft"
        type="text"
        :placeholder="$t('validStatuses.placeholder')"
        @keydown.enter.prevent.stop="add(draft)"
      />
    </div>

    <div v-if="integrationId" class="valid-statuses__seen">
      <div class="valid-statuses__seen-title">
        {{ $t("validStatuses.seen") }}
        <span v-if="loading">{{ $t("validStatuses.seenLoading") }}</span>
      </div>
      <div v-if="!loading && !seen.length" class="valid-statuses__empty">
        {{ $t("validStatuses.seenEmpty") }}
      </div>
      <button
        v-for="item in seen"
        :key="item.status"
        type="button"
        :class="['valid-statuses__seen-item', isSelected(item.status) && 'active']"
        @click="toggle(item.status)"
      >
        {{ item.status }} <span>{{ item.count }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import leadApi from "~/api/lead";

// Список статусов партнёра, которые считаются валидными (поле valid_statuses интеграции).
export default {
  name: "ValidStatusesField",
  props: {
    value: { type: Array, default: () => [] },
    // для существующей интеграции показываем статусы, которые реально приходили от партнёра
    integrationId: { type: [Number, String], default: null },
    inputId: { type: String, default: "valid-status-input" },
  },
  data() {
    return { draft: "", seen: [], loading: false };
  },
  watch: {
    integrationId: {
      immediate: true,
      handler(id) {
        if (id) this.loadSeen(id);
      },
    },
  },
  methods: {
    normalize(status) {
      return String(status).trim().toLowerCase();
    },
    isSelected(status) {
      return this.value.some((s) => this.normalize(s) === this.normalize(status));
    },
    add(status) {
      const clean = String(status || "").trim();
      if (clean && !this.isSelected(clean)) this.$emit("input", [...this.value, clean]);
      this.draft = "";
    },
    remove(status) {
      this.$emit(
        "input",
        this.value.filter((s) => this.normalize(s) !== this.normalize(status)),
      );
    },
    toggle(status) {
      if (this.isSelected(status)) this.remove(status);
      else this.add(status);
    },
    loadSeen(id) {
      this.loading = true;
      leadApi
        .getPartnerStatuses(id)
        .then((res) => {
          this.seen = (res.data && res.data.items) || [];
        })
        .catch(() => {
          this.seen = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.valid-statuses {
  display: flex;
  flex-direction: column;
  gap: 8px;

  &__hint,
  &__empty {
    font-size: 13px;
    color: $mainSecondTextColor;
  }

  &__chips {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
    padding: 6px;
    border: 1px solid $mainDisabled;
    border-radius: 7px;
    background: #fff;

    input {
      flex: 1;
      min-width: 200px;
      height: 30px;
      padding: 0 6px;
      border: 0 !important;
      outline: none;
      box-shadow: none !important;
    }
  }

  &__chip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 3px 4px 3px 10px;
    border-radius: 99px;
    background: $coffee;
    color: #fff;
    font-size: 13px;

    button {
      width: 18px;
      height: 18px;
      border: 0;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.25);
      color: #fff;
      line-height: 1;
      cursor: pointer;
    }
  }

  &__seen {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }

  &__seen-title {
    width: 100%;
    font-size: 13px;
    font-weight: 600;
    color: $mainSecondTextColor;
  }

  &__seen-item {
    padding: 4px 10px;
    border: 1px dashed $mainDisabled;
    border-radius: 99px;
    background: #fff;
    font-size: 13px;
    cursor: pointer;

    span {
      margin-left: 4px;
      color: $mainSecondTextColor;
      font-size: 12px;
    }

    &.active {
      border-style: solid;
      border-color: $coffee;
      font-weight: 600;
    }
  }
}
</style>
